<template>
    <header class="header" :style="[{'margin-bottom': notification ? '100px' : '0'}]">
        <div class="header-container">
            <div class="header-item">
                <div class="header-item_sidebar">
                    <button class="open" @click="$emit('toggleSidebar')">
                        <img src="@/assets/img/header/menu.svg" alt="">
                    </button>
                    <img src="@/assets/img/header/logo.png" @click="$router.push({name: 'main'})" alt="" class="header-logo">
                </div>
                <div class="header-item_title" :class="{arrow: $route.meta['back'+$store.getters.getCompany.type] != undefined}">
                    <img v-if="$route.meta['back'+$store.getters.getCompany.type] != undefined" src="../assets/icons/arrow-header.svg" class="back" alt="" @click="redirect()">
                    <h1>{{ header_title ? header_title : $route.meta.title }}</h1>
                </div>
            </div>
            <div class="header-item" v-if="getCompany != null">
<!--                <div class="header-search">-->
<!--                    <input name="search" placeholder="Поиск">-->
<!--                    <img src="@/assets/img/header/search.svg" alt="">-->
<!--                </div>-->
                <app-notifications/>
               <!-- <button class="header-icon">
                    <img src="@/assets/img/header/question.svg" alt="" />
                </button>-->
                <div class="header-icon dropdown">
                    <div class="dropbtn">
                        <div class="container_avatar">
                            <img src="@/assets/img/header/question.svg" alt="" />
                        </div>
                    </div>
                    <div class="dropdown-content instr">
                        <a :href="url" class="instr-link">Скачать инструкцию</a>
                        <a v-if="type == 1" :href="install_url" class="instr-link">Скачать инструкцию по установке модуля</a>
                        <a v-if="type == 1" :href="module_url" class="instr-link">Скачать модули для 1С</a>
                    </div>
                </div>
                <div class="header-user dropdown">
                    <div class="dropbtn">
                        <div class="container_avatar">
                          <img class="avatar" :src="getAvatar(getCompany.photo)" alt="" >
                        </div>
                        <span class="nickname">{{getCompany.name}}</span>
                    </div>
                    <div class="dropdown-content">
                      <router-link tag='div' :to="{name: 'wprofile'}">Мой профиль</router-link>
                      <router-link v-if="can('page.organization.profile')" tag='div' :to="{name: 'oprof'}">Профиль организации</router-link>
                      <div class="exit" @click="logOut()">Выход</div>
                    </div>
                </div>
            </div>
        </div>
    </header>
</template>

<script>
import { mapGetters, mapMutations } from 'vuex'
import AppNotifications from "@/components/app-notifications";
export default {
    name: "Header",
  components: { AppNotifications },
  props: ['title', 'notification'],
    data: ()=>({
        logo: '',
        name: '',
        token: '',
        header_title: '',
        url: '',
        type: '',
        install_url: '',
        module_url: ''
    }),
    mounted() {
        this.type = localStorage.getItem('type');
        const token = localStorage.getItem('token');
        this.url = `${process.env.VUE_APP_BACKEND_URL}/export-instruction?token=${token}`;
        this.install_url = `${process.env.VUE_APP_BACKEND_URL}/export-install-instruction?token=${token}`;
        this.module_url = `${process.env.VUE_APP_BACKEND_URL}/export-module?token=${token}`;
        this.$root.$on('changeHeaderTitle', (title) => this.header_title = title);
    },
    methods: {
      ...mapMutations(['logOut']),
      hasHistory () { return window.history.length > 2 },
      redirect() {
        if (this.hasHistory() && this.$route.meta.backHistory != undefined) {
          this.$router.go(-1);
        } else {
          let type = this.$store.getters.getCompany?.type;

            if (this.$route.meta['back'+type] != '' && this.$route.meta['back'+type]) {
                this.$router.push({name: this.$route.meta['back'+type]})
            }
        }

      },
      getAvatar(avatar){
        if(avatar == 'https://api.superbaer24.ru/storage/') return require('@/assets/icons/user-nav.svg')
        else return avatar
      }
    },
  computed: {
      ...mapGetters(['getCompany'])
  }
}
</script>

<style scoped lang="scss">
  .dropbtn {
      cursor: pointer;
      height: 100%;
      background-color: initial;
      border: none;
      margin: 13px 0;
      outline: none;
  }
  .dropdown {
      position: relative;
  }
  .dropdown-content {
      display: none;
      top: 53px;
      right: -10px;
      position: absolute;
      background: #2CB181;
      border-radius: 0px 0px 4px 4px ;
      min-width: 160px;
      z-index: 1;
      padding: 5px 3px 8px 4px;
  }

  .instr {
      right: -40px;
  }
  .dropdown-content div, .instr-link {
      font-family: Roboto;
      cursor: pointer;
      font-style: normal;
      font-weight: 500;
      font-size: 11px;
      line-height: 13px;
      color: #A9ECD0;
      padding: 0 16px;
      text-decoration: none;
      display: block;
      margin-bottom: 6px;
      &.exit{
          margin-top: 15px;
      }
  }
  .dropdown-content div:hover, .instr-link:hover {color: rgba(169, 236, 208, 0.70);}
  .dropdown:hover .dropdown-content {display: block;}
  .dropdown:hover .dropbtn {background-color: rgba(41, 165, 121, 0.18);}
  .header {
    margin-bottom: 90px;
    background: #2CB181;
    height: 50px;

    &-container {
        padding: 7.5px 15px;
        display: flex;
        align-items: center;
        height: 100%;
        justify-content: space-between;
    }

    &-item {
        display: flex;
        align-items: center;

        > div {
            display: flex;
            align-items: center;
        }

        &_sidebar {
            width: 185px;

            & .open {
                width: 20px;
                background: none;
                border: none;
                outline: none;
                margin-right: 18px;

                > img {
                    width: 100%;
                    height: 100%;
                }
            }
        }

        &_title {
            margin-left: 30px;


            > h1 {
                color: #F9F9FB;
                font-weight: 500;
                font-size: 18px;
                margin-bottom: 0px;
            }
            &.arrow{
              margin-left: 0px;
            }
            .back {
              cursor: pointer;
              margin-right: 10px;
            }
        }

    }

    &-logo {
        width: auto;
        height: 35px;
        cursor: pointer;
    }

    &-search {
        width: 310px;
        height: 35px;
        position: relative;
        margin-right: 10px;

        > input {
            height: 100%;
            width: 100%;
            background: #29A377;
            border-radius: 4px;
            border: none;
            outline: none;

            color: #F9F9FB;
            padding: 0 35px 0 15px;

            &::placeholder {
                color: #A9ECD0;
            }
        }

        > img {
            width: 14px;
            height: 14px;

            position: absolute;
            right: 15px;
        }
    }

    &-icon {
        background: none;
        border: none;
        outline: none;
        margin: 0 10px;

      &.rel{
        position: relative;
      }
    }

    &-user {
        margin-left: 10px;
        & .nickname {
            font-weight: 500;
            font-size: 11px;
            line-height: 13px;
            color: #A9ECD0;
            width: 80px;
        }

        & .avatar {
          width: 100%;
          height: 100%;
            //height: 27px;
            //width: 27px;
            border: 1px solid #A9ECD0;
            object-fit: cover;
          border-radius: 100%;
            border: 1px solid #A9ECD0;
            margin-right: 7px;
        }
    }
}
  .container_avatar{
    width: 27px;
    height: 27px;
    float: left;
    margin-right: 5px;
  }

</style>
